import { transactionItems } from '../utils/collections';
import { fireAuth, handleMultiDocument } from '../utils/firebase';

export const transactionItemsRef = (field = 'clientID') => {
  const clientID = fireAuth.currentUser.uid;
  return transactionItems.where(field, '==', clientID);
};

export const getTransactionItems = (field) => {
  transactionItemsRef(field).get().then(handleMultiDocument);
};

export const onTransactionItems = (field, callback) =>
  transactionItemsRef(field).onSnapshot((snapshot) => callback(handleMultiDocument(snapshot)));

export const getSellerTransactionItems = () => getTransactionItems('sellerID');
export const onSellerTransactionItems = (callback) => onTransactionItems('sellerID', callback);
export const getClientTransactionItems = () => getTransactionItems('clientID');
export const onClientTransactionItems = (callback) => onTransactionItems('clientID', callback);
